import { Button } from "@/components/button";
import { CatchPraise } from "@/components/catchPraise";
import { useGetCommon, type AsideBannerResponse } from "@/shared/server";
import { Spinner } from "@chakra-ui/react";
import { CustomBox, CustomFlex, Wrapper } from "./asideBanner.style";
import { type AsideBannerProps } from "./asideBanner.type";

export const AsideBanner = ({ isFullImg }: AsideBannerProps) => {
    const { data } = useGetCommon<AsideBannerResponse>({ section: "aside" });
    const onLink = (url: string) => {
        window.open(url, "_blank");
    };

    return data ? (
        <Wrapper position="relative" zIndex="1" isFullImg={isFullImg}>
            {isFullImg && (
                <CustomBox
                    w="100%"
                    h="480px"
                    opacity="0.7"
                    background={`url(${data.imgUrl}) no-repeat center/cover fixed`}
                ></CustomBox>
            )}
            <CustomFlex as="section" flexDir="column" alignItems="center" rowGap="40px">
                <CatchPraise catchPraise={data.catchPraise} isDetail={false} />
                <Button iconNamed="notifications" size="medium" onClick={() => onLink(data.bookingUrl)}>
                    예약하기
                </Button>
            </CustomFlex>
        </Wrapper>
    ) : (
        <Spinner />
    );
};
